import { render, staticRenderFns } from "./PaymentMethodList.vue?vue&type=template&id=64170188&"
import script from "./PaymentMethodList.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodList.vue?vue&type=style&index=0&id=64170188&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports